import { Navigate } from "react-router"

import { useProduct } from "@/contexts/product-context"
import {
  isStudentHomeSession,
  STUDENT_EXXAT_ONE_PRODUCT,
} from "@/lib/student-exxat-one-home"
import { studentExxatOneProductLandingPath } from "@/lib/student-exxat-one-utility-bar"
import { productSlug } from "@/stores/app-store"

import ProductDashboard from "./_product-dashboard"

/** Students land on Home, not the coordinator dashboard, when opening Exxat One. */
export default function ProductDashboardWithStudentOneRedirect() {
  const { product } = useProduct()

  if (isStudentHomeSession() && product === STUDENT_EXXAT_ONE_PRODUCT) {
    return (
      <Navigate
        to={studentExxatOneProductLandingPath(productSlug(product))}
        replace
      />
    )
  }

  return <ProductDashboard />
}
